import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
  Tab,
  Tabs,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ULoading, UText } from "@/components/index"
import { StageNumber } from "./StageNumber"
import { OrderLabel } from "./OrderLabel"
import { UndercutFill } from "./UndercutFill"
import { TrimLine } from "./TrimLine"
import { PrintOthers } from "./PrintOthers"
import SelectStage from "./SelectStage"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import { caseManagement, stagingManager, wasmModule } from "@/gluelayer"
import {
  clearPrintedStageInPrint,
  setIsPrintAsDPA,
  setOpenLabelPreview,
  setOpenReviewPrint,
  setOpenStlPrint,
  setOpenTrimPreview,
  setOpenUndercutPreview,
  setPrintedStageInPrint,
  setSelectStageInPrint,
  setStageShowType,
  setPrintSettings,
} from "@/UDTreat/udTreatSlice"
import { useCanvasHeight } from "@/UDTreat/top/GetViewWidth"
import {
  EPrintModel,
  IPrintSettingJsonObj,
} from "@/core/app/slices/user/user.type"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { UButton } from "@/components/index"
import { set } from "react-hook-form"
import {
  setIsShowProgress,
  setProgressMsg,
} from "@/core/app/slices/clinical/clinicalSlice"
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{
        visibility: value === index ? "visible" : "hidden",
        height: value === index ? "auto" : 0,
      }}
    >
      {children}
    </div>
  )
}
export const OrderStlPrint = () => {
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const {
    openStlPrint,
    selectStageInPrint,
    openLabelPreview,
    openUndercutPreview,
    openTrimPreview,
    openReviewPrint,
    printSettings,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const dispatch = useAppDispatch()
  const [tabVal, setTabVal] = useState<number>(0)
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === undefined) {
      return
    }
    setTabVal(newValue)
  }
  const {
    patientData: { firstName = "", lastName = "" },
  } = useAppSelector((state: RootState) => {
    return state.patientService
  })

  const getArch = (udesign_category) => {
    let caseArch = "both",
      UpperType = "A",
      LowerType = "A"

    if (!udesign_category) return caseArch
    UpperType = udesign_category.split("/")[0]

    LowerType = udesign_category.split("/")[1]

    if (UpperType.includes("--")) {
      caseArch = "lower"
    } else if (LowerType.includes("--")) {
      caseArch = "upper"
    }

    return { caseArch, UpperType, LowerType }
  }

  const {
    firstStage: { upStageIndex: upTempIndex, lowerStageIndex: lowerTempIndex },
  } = caseManagement.getAttachmentIPRReport()

  const [jsonData, setJsonData] = useState<IPrintSettingJsonObj>(
    {} as IPrintSettingJsonObj,
  )
  const { clinicalSettings } = useAppSelector(
    (state: RootState) => state.userService,
  )
  const { CuttingLineCC, CuttingLineCP, CuttingLineOffset } = clinicalSettings
  const updateJsonData = (data: IPrintSettingJsonObj) => {
    // setJsonData(data)
    const dataName =
      printSettings.DefaultModel === EPrintModel.StandardModel
        ? "StandardModel"
        : printSettings.DefaultModel === EPrintModel.DPAModel
        ? "DpaModel"
        : "LuxcreoModel"
    const srcData =
      printSettings.DefaultModel === EPrintModel.StandardModel
        ? printSettings.StandardModel
        : printSettings.DefaultModel === EPrintModel.DPAModel
        ? printSettings.DpaModel
        : printSettings.LuxcreoModel
    const updatedSettings = {}
    updatedSettings[dataName] = { ...srcData, ...data }
    dispatch(setPrintSettings({ ...printSettings, ...updatedSettings }))
  }

  useEffect(() => {
    const initSetting = { ...clinicalSettings.PrintSetting, ...printSettings }
    console.log("init printSetting:", initSetting)
    // Initialize print settings
    dispatch(setPrintSettings(initSetting))

    // Clear setting cache when close clinical.
  }, [])

  useEffect(() => {
    console.log("printSettings????????:", printSettings)
    if (!printSettings.DefaultModel) {
      return
    }
    const settingData =
      printSettings.DefaultModel === EPrintModel.StandardModel
        ? printSettings.StandardModel
        : printSettings.DefaultModel === EPrintModel.DPAModel
        ? printSettings.DpaModel
        : printSettings.LuxcreoModel
    setExportModel(printSettings.DefaultModel)
    setJsonData(settingData)
  }, [printSettings])

  const printStage = async () => {
    return new Promise((resolve, reject) => {
      if (
        selectStageInPrint.up.length <= 0 &&
        selectStageInPrint.low.length <= 0
      ) {
        reject("Please select the stage to print")
        return
      }
      console.log("🚀 ~ printStage ~ selectStageInPrint:", selectStageInPrint)

      setTimeout(() => {
        const modulePrintSelection =
          wasmModule.moduleManager.GetModulePrintSelection()
        if (!modulePrintSelection) return reject("ModulePrintSelection is null")

        modulePrintSelection.SetNameInfo(firstName, lastName)
        modulePrintSelection.SetCaseID(caseDetail.id.toString())

        const upStageCount = stagingManager.stageUpnNumber
        const lowerStageCount = stagingManager.stageLowNumber

        const handleStage = (
          items: number[],
          tempIndex: number,
          stageCount: number,
          isLower: boolean,
        ) => {
          const arch = isLower ? 1 : 0
          items.forEach((item) => {
            if (item === 400) {
              modulePrintSelection.AddStage(Math.max(0, tempIndex - 1), 2, arch)
            } else if (item === 500) {
              // Retainer stage
              modulePrintSelection.AddStage(stageCount, 1, arch)
            } else {
              // Normal stage
              modulePrintSelection.AddStage(item, 0, arch)
            }
          })
        }

        handleStage(selectStageInPrint.up, upTempIndex, upStageCount, false)
        handleStage(
          selectStageInPrint.low,
          lowerTempIndex,
          lowerStageCount,
          true,
        )

        modulePrintSelection.OnPrintButtonDown()
        resolve("Print stage success")
      }, 200)
    })
  }
  const disabledStyle =
    openLabelPreview || openUndercutPreview || openTrimPreview
      ? {
          pointerEvents: "none",
          opacity: 0.7,
        }
      : {}
  // clear preview data
  useEffect(() => {
    return () => {
      dispatch(setOpenLabelPreview(false))
      dispatch(setOpenUndercutPreview(false))
      dispatch(setOpenTrimPreview(false))
      dispatch(setOpenReviewPrint(false))
      dispatch(setStageShowType("normal"))
    }
  }, [])

  // set preview canvas window height
  const canvasHeight = useCanvasHeight()
  useEffect(() => {
    try {
      if (openLabelPreview || openUndercutPreview || openTrimPreview) {
        if (openLabelPreview) {
          wasmModule.statusController.ResizePrintRendererInHeight(
            164 / canvasHeight,
          )
        }
        if (openTrimPreview) {
          wasmModule.statusController.ResizePrintRendererInHeight(
            244 / canvasHeight,
          )
        }
        if (openUndercutPreview) {
          wasmModule.statusController.ResizePrintRendererInHeight(
            412 / canvasHeight - 0.05,
          )
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [openLabelPreview, openUndercutPreview, openTrimPreview, canvasHeight])
  // select position
  const [toothPosition, setToothPosition] = useState<string>("") // Bottom /WallLingual/ Wall
  // hollow model
  const [hollowModel, setHollowModel] = useState<number>(0)
  // trim line value
  const [trimValue, setTrimValue] = useState(null) // 1: no trim machine, 2: digital dental trim machine, 3: general trim machine
  // export model
  const [exportModel, setExportModel] = useState<EPrintModel>(
    EPrintModel.StandardModel,
  ) //1: standard , 2:DPA, 3:LuxCreo
  // DPA and LuxCreo to wasm
  useEffect(() => {
    try {
      if (!wasmModule.moduleManager.GetModulePrintSelection()) return
      dispatch(clearPrintedStageInPrint())

      dispatch(setIsPrintAsDPA(exportModel === EPrintModel.DPAModel))
      if (exportModel === EPrintModel.DPAModel) {
        // if select DPA and label will go stagenumber
        if (tabVal === 1) {
          setTabVal(0)
        }
        wasmModule.moduleManager.GetModulePrintSelection().SetDPAEnable(true)
      } else {
        wasmModule.moduleManager.GetModulePrintSelection().SetDPAEnable(false)
      }
      if (exportModel === EPrintModel.LuxcreoModel) {
        // if select Luxcreo and label or others will go stagenumber
        if (tabVal === 1 || tabVal === 4) {
          setTabVal(0)
        }
        wasmModule.moduleManager
          .GetModulePrintSelection()
          .SetLuxCreoEnable(true)
      } else {
        wasmModule.moduleManager
          .GetModulePrintSelection()
          .SetLuxCreoEnable(false)
      }
    } catch (error) {
      console.error(error)
    }
  }, [exportModel])
  // stage show or hide
  useEffect(() => {
    if (
      openLabelPreview ||
      openUndercutPreview ||
      openTrimPreview ||
      openReviewPrint
    ) {
      dispatch(setStageShowType(""))
    } else {
      dispatch(setStageShowType("normal"))
    }
  }, [openLabelPreview, openUndercutPreview, openTrimPreview, openReviewPrint])

  // pass cuttingline value to wasm
  useEffect(() => {
    const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
    if (printMoudle) {
      try {
        printMoudle.SetTrimLineAnteriorType(+CuttingLineCC)
        printMoudle.SetTrimLinePosteriorType(+CuttingLineCP)
        printMoudle.SetTrimLineOffsetType(+CuttingLineOffset)
      } catch (error) {
        console.log(error)
      }
    }
  }, [wasmModule.moduleManager.GetModulePrintSelection()])

  // check label length pop-up
  const [labelWarning, setLabelWarning] = useState<boolean>(false)
  // process pop-up
  const [processWarning, setProcessWarning] = useState<boolean>(false)
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
      }}
    >
      <Box sx={{ width: "100%", textAlign: "left", marginBottom: "24px" }}>
        <UText variant={"h4"}>{`Print STL Model: Settings`}</UText>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <UText variant={"h6"}>{`Export as`}</UText>
        <Select
          sx={{
            width: "260px",
            height: "40px",
            marginLeft: "8px",
            background: "#fff",
          }}
          displayEmpty
          value={exportModel}
          onChange={(eve) => {
            console.log("exportModel:", eve.target.value)
            setExportModel(eve.target.value)
            dispatch(setPrintSettings({ DefaultModel: eve.target.value })) // Update print settings with selected model
          }}
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        >
          <MenuItem
            value={EPrintModel.StandardModel}
          >{`Standard Model`}</MenuItem>
          <MenuItem
            value={EPrintModel.DPAModel}
          >{`DPA (Direct Print Aligner)`}</MenuItem>
          <MenuItem value={EPrintModel.LuxcreoModel}>{`LuxCreo`}</MenuItem>
        </Select>
      </Box>
      <Tabs
        value={tabVal}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          "& .MuiTab-root": {
            padding: "9px 16px",
            fontSize: "14px",
            fontWeight: "500",
            minWidth: "unset",
            maxWidth: "unset",
            letterSpacing: "0.4px",
            textTransform: "uppercase",
          },
        }}
      >
        <Tab
          label="Stage number"
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        />
        <Tab
          label="Label"
          disabled={
            openLabelPreview ||
            openUndercutPreview ||
            openTrimPreview ||
            exportModel === EPrintModel.DPAModel ||
            exportModel === EPrintModel.LuxcreoModel
          }
        />
        <Tab
          label="Digital Fill"
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        />
        <Tab
          label="Trim"
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        />
        <Tab
          label="Others"
          disabled={
            openLabelPreview ||
            openUndercutPreview ||
            openTrimPreview ||
            exportModel === EPrintModel.LuxcreoModel
          }
        />
      </Tabs>

      <Box
        sx={{
          background: "#fff",
          padding: "24px",
          height: "352px",
          "& .MuiInput-root, & .MuiFormControlLabel-root, & .MuiFormControl-root":
            {
              ...disabledStyle,
            },
        }}
      >
        <CustomTabPanel value={tabVal} index={0}>
          <StageNumber jsonData={jsonData} updateJsonData={updateJsonData} />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={1}>
          <OrderLabel
            exportModel={exportModel}
            jsonData={jsonData}
            updateJsonData={updateJsonData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={2}>
          <UndercutFill jsonData={jsonData} updateJsonData={updateJsonData} />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={3}>
          <TrimLine
            exportModel={exportModel}
            jsonData={jsonData}
            updateJsonData={updateJsonData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={4}>
          <PrintOthers
            exportModel={exportModel}
            jsonData={jsonData}
            updateJsonData={updateJsonData}
          />
        </CustomTabPanel>
      </Box>

      {/* stage */}
      <SelectStage />

      <Button
        onClick={() => {
          //判断selectStageInPrint是否为空
          if (
            selectStageInPrint.up.length <= 0 &&
            selectStageInPrint.low.length <= 0
          )
            return

          //check label length,if up 10 will show the pop-up
          //getLabelLength
          try {
            const labelLength = wasmModule.moduleManager
              .GetModulePrintSelection()
              .GetLabelMaxLength()
            console.log("labelLength", labelLength)
            if (labelLength > 10) {
              setLabelWarning(true)
              console.log("The length of tag can't be greater than 10!")
              return
            }
          } catch (error) {
            console.log(error)
          }

          setProcessWarning(true)
        }}
        variant="contained"
        sx={{
          padding: "6px 16px",
          width: "150px",
          height: "36px",
          marginLeft: "auto",
        }}
        disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
      >{`next`}</Button>

      {/* check label length pop-up */}
      <Dialog open={labelWarning}>
        <DialogTitle
          sx={{ padding: "16px 24px", display: "flex", alignItems: "center" }}
        >
          <WarningAmberIcon sx={{ color: "#ED6C02", marginRight: "8px" }} />
          <Typography variant="h6" color={"rgba(0, 0, 0, 0.87)"}>
            Tag Warning
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "12px" }}>
          <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
            The length of tag can't be greater than 10!
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "end",
            padding: "8px 14px 8px 24px",
          }}
        >
          <UButton
            onClickHandler={() => {
              setLabelWarning(false)
            }}
            variant={"contained"}
            btnText={"OK"}
          />
        </DialogActions>
      </Dialog>

      <Dialog open={processWarning}>
        <DialogTitle
          sx={{ padding: "16px 24px", display: "flex", alignItems: "center" }}
        >
          <WarningAmberIcon sx={{ color: "#D32F2F", marginRight: "8px" }} />
          <Typography variant="h6" color={"rgba(0, 0, 0, 0.87)"}>
            Preparing Your Download:
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "12px" }}>
          <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
            Please wait while we process your files.
          </Typography>

          <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
            This may take a few moments.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "right",
            padding: "8px 14px 8px 24px",
          }}
        >
          <UButton
            onClickHandler={() => {
              setProcessWarning(false)
              dispatch(setIsShowProgress(true))
              dispatch(setProgressMsg("Processing... Please stand by."))
              dispatch(setOpenReviewPrint(true))

              printStage()
                .then((res) => {
                  console.log("printStage:", res)
                  dispatch(setPrintedStageInPrint(selectStageInPrint))
                })
                .catch((err) => {
                  console.log("printStage error:", err)
                })
                .finally(() => {
                  dispatch(setIsShowProgress(false))
                })
            }}
            variant={"contained"}
            btnText={"OK"}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}
